import { Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import FormProvider from "src/components/hook-form";
import Scrollbar from "src/components/scrollbar";
import { Transition } from "src/shorts/Transition";
import { useModel } from "./useModel";
import { ActionModalProps } from "./types";
import { DevTool } from "@hookform/devtools";
import { ConfirmModal } from "../ConfirmModal";
import { ConfirmDrawerModal } from "./ConfirmDrawerModal";
import { FormDrawerModal } from "./FormDrawerModal";


export const ActionModal = (props: ActionModalProps) => {
  const { onClose, title, rows, onAction, config, methods, cols, defaultValuesData, initData, validationErrors, errorsDrawerOpen, onCloseErrorsDrawer, formFieldLabels } = useModel(props);
  const { Form, withDevtools, description, type, withCustomDescription } = config;

  if (type === 'dialog' && !Form) {
    return <ConfirmModal onAction={onAction} title={title} rows={rows} onClose={onClose} cols={cols} />
  }

  if (type === 'drawer' && !Form) {
    return <ConfirmDrawerModal onAction={onAction} title={title} rows={rows} onClose={onClose} cols={cols} />
  }

  if (type === 'drawer' && Form) {
    return (
      <FormDrawerModal
        onAction={onAction}
        title={title}
        onClose={onClose}
        methods={methods}
        drawerWidth={config?.drawerWidth}
        validationErrors={validationErrors}
        errorsDrawerOpen={errorsDrawerOpen}
        onCloseErrorsDrawer={onCloseErrorsDrawer}
        formFieldLabels={formFieldLabels}
        actionLabel={config?.actionLabel}
      >
        <Form defaultValues={defaultValuesData} initData={initData} rows={rows} methods={methods} />
      </FormDrawerModal>
    )
  }

  return (
    <Dialog
      open
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <FormProvider methods={methods}>
        <DialogTitle id="alert-dialog-slide-title">{title || 'Do you want to continue?'}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {!withCustomDescription && (
              <Box mb={1}>{description || `The action will be applied to the following ${rows.length} documents`}:</Box>
            )}
            <Scrollbar sx={{ maxHeight: '200px' }}>
              {Form && (
                <Form defaultValues={defaultValuesData} initData={initData} rows={rows} methods={methods} />
              )}
            </Scrollbar>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button color="inherit" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="contained" onClick={onAction}>
            Continue
          </Button>
        </DialogActions>
        {withDevtools && <DevTool control={methods.control} />}
      </FormProvider>
    </Dialog>
  )
}
 